"use client";

import { useState } from "react";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";
import BottomSheetModal from "@/components/ui/BottomSheetModal/BottomSheetModal";
import { useTranslations } from "next-intl";

export default function SelectedMentorBadge() {
    const t = useTranslations();
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                className="inline-flex items-center gap-1.5 text-white bg-white/10 hover:bg-white/20 transition-colors rounded-full px-3 py-1 text-sm font-semibold"
            >
                <SolarIcon
                    name="verified-check-bold"
                    className="text-base text-[#ff6a3d]"
                />
                {t("mentoring_selected_mentor")}
                <SolarIcon
                    name="info-circle-linear"
                    className="text-sm text-white/50"
                />
            </button>

            <BottomSheetModal
                isOpen={open}
                onClose={() => setOpen(false)}
                maxWidthClass="sm:max-w-md"
                zIndexClass="z-[60]"
            >
                <div className="relative p-7 text-gray-900 dark:text-white">
                    <button
                        type="button"
                        onClick={() => setOpen(false)}
                        className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-white/20 transition-colors"
                        aria-label={t("mentor_selected_modal_close")}
                    >
                        <SolarIcon
                            name="close-circle-bold-duotone"
                            className="text-lg text-gray-500 dark:text-grayDark-300"
                        />
                    </button>

                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                        <SolarIcon
                            name="verified-check-bold"
                            className="text-2xl text-primary"
                        />
                    </div>
                    <h2
                        id="selected-mentor-title"
                        className="text-xl font-bold font-sourceSans text-gray-900 dark:text-white mt-4"
                    >
                        {t("mentor_selected_modal_title")}
                    </h2>
                    <p className="text-[#05060F]/70 dark:text-lightBlue mt-3 leading-relaxed">
                        {t("mentor_selected_modal_description")}
                    </p>
                </div>
            </BottomSheetModal>
        </>
    );
}
